<template>
  <div>
    <Header />
    <component
      :is="dialogConfig.name"
      :dialogConfig="dialogConfig"
      @cancleDialog="cancleDialog(arguments)"
    ></component>
    <div class="main">
      <div class="c">
        <div class="title">
          <div class="return" @click="back()">
            <a-icon type="left" />
            <span>返回</span>
          </div>
          <span class="assessName">{{ this.assessName }}</span>
        </div>
        <div class="paper">
          <div class="paper-left">
            <component
              :is="tebActive"
              :questionData="questionData"
              :key="questionData.index"
            
            ></component>
              <!-- v-on:upload="uploaded" -->
          </div>
          <div class="paper-right">
            <p class="time" v-if="limit_time && limit_time > 0" ref="timeDom"> </p>
            <p class="time" v-else ref="useTime"></p>
            <div class="paper-right-title">答题卡</div>
            <div class="paper-right-selects">
              <ul>
                <li
                  v-for="(item, index) in questions"
                  :key="item.que_id"
                  ref="li"
                  :style="{
                    background:
                      index == currentIndex ? '#2462F5' : item.answerState,
                    color: index == currentIndex ? '#fff' : item.answerColor,
                  }"
                  @click="toQuestion(item, index)"
                >
                  {{ item.num }}
                  <img
                    v-show="item.is_sign == 1"
                    src="../../../assets/sign.png"
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div class="tip">
              <span>已答</span>
              <div class="answered"></div>
              <span>未答</span>
              <div class="noAnswer"></div>
            </div>
            <div class="submit" @click="submitAssess()">提交</div>
          </div>
        </div>
        <div class="button-box" v-if="this.questions.length > 1">
          <div class="buPrevious" ref="buPrevious" @click="previous()">
            上一题
          </div>
          <div class="buNext" ref="buNext" @click="next()">下一题</div>
        </div>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import radio from "./NowPractice/radio";
import checkbox from "./NowPractice/checkbox";
import fillBlanks from "./NowPractice/fillBlanks";
import quesAnswer from "./NowPractice/quesAnswer";
import combination from "./NowPractice/combination.vue";
import judge from "./NowPractice/judge";
import services from "../../../config/services";
import { mapActions, mapState } from "vuex";
import { Modal } from "ant-design-vue";
export default {
  name: "assessAnswer",
  components: {
    Footer,
    Header,
    radio,
    checkbox,
    fillBlanks,
    quesAnswer,
    judge,
    combination,
    assessDialog1: () => import("./BaseDialog/assessDialog1.vue"),
    assessDialog2: () => import("./BaseDialog/assessDialog2.vue"),
  },
  data() {
    return {
      tebActive: null,
      questionData: "",
      questions: "",
      cardInfo: "", //答题卡信息
      ass_id: this.$route.query.ass_id,
      class_id: this.$route.query.class_id, //测评id
      assessName: this.$route.query.assessName,
      questionId: '', //当前question id
      questionType: '', //当前question type
      currentIndex: 0, //当前位置
      isAnswer: false, //是否作答
      color: "#fff",
      answerForm: {
        ass_id: this.$route.query.ass_id,
        answer_data: [],
      },
      tab: 1,
      // cost: this.$route.query.cost ? this.$route.query.cost : 0,
      limit_time: 0,//测评结束时间 秒
      timer: "",
      timer1: "",
      time1: parseInt(0),
      dialogConfig: {
        name: "",
        title: "",
        data: {
          use_duration:'',
          show_result: ''
        },
        dialogVisible: true,
      },
      uploadQueID: [], //已经上传文件的问题的id
      record_id: '', // 测评记录id
      isSubmitting: false, // 是否正在提交作答 避免重复提交
      show_result: 1, // 是否展示测评结果 1开启 2关闭
      use_duration: '', // 用时
    };
  },
  created() {
    let that = this

    if(this.$route.query.show_result){
      that.show_result = this.$route.query.show_result
    }

    services
      .assessCard({
        exam_id: this.ass_id,
        class_id: this.class_id,
      })
      .then((res) => {
        if(res.code == '0000'){
        that.questions = res.data.items;
        that.record_id = res.data.record_id
        // 获取过期时间expire_time 赋值倒计时时间limit_time
        if(res.data.expire_time){
          let currentTime = new Date().getTime();
          let expiretime = new Date(res.data.expire_time)*1;
          if(expiretime - currentTime > 0){
            that.limit_time = Math.floor((expiretime - currentTime)/1000) 
          }
        }
        that.stratCoundown()

        that.questionId = that.questions[0].que_id
        that.questionType = that.questions[0].type
        that.questions.forEach(function (item) {
          that.colorFunc(item);
        });

        services.questionGetbyassess({
            exam_id: this.ass_id,
            que_id: this.questions[0].que_id,
            class_id: this.class_id,
            record_id: this.record_id,
            is_again: 2,
          }).then((second) => {
            // if (second.code == "0000") {
              this.questions[0] =  Object.assign(this.questions[0], second.data);
              let obj1 = {
                que_id: this.questions[0].que_id,
                parent_id: this.questions[0].parent_id,
                answer: "",
                is_sign: "2",
              };
              if(second.data && second.data.user_log && second.data.user_log.answer) {
                obj1.answer = second.data.user_log.answer
              }
              if(second.data && second.data.user_log && second.data.user_log.is_sign) {
                obj1.is_sign = second.data.user_log.is_sign
              }
              if (this.questions[0].type == "1") {
                this.tebActive = "radio";
              }
              if (this.questions[0].type == "2") {
                this.tebActive = "checkbox";
              }
              if (this.questions[0].type == "3") {
                this.tebActive = "judge";
              }
              if (this.questions[0].type == "4") {
                this.tebActive = "quesAnswer";
                if(second.data && second.data.user_attachment){
                  obj1.attachment = second.data.user_attachment
                }
              }
              if (this.questions[0].type == "5") {
                this.tebActive = "combination";
                if(second.data && second.data.user_attachment){
                  obj1.attachment = second.data.user_attachment
                }
              }
              
              this.answerForm.answer_data.push(obj1);
              this.questionData = {
                data: this.questions[0],
                index: this.currentIndex,
                form: this.answerForm.answer_data[0],
                isAssess: '2', // 1练习 2 测评
                ass_id: this.ass_id,
                record_id: this.$route.query.record_id,
              };
            
            // }
          });
        } else {
          that.$message.error(res.message ? res.message :'获取答题卡失败')
          if(res.code == '2004'){
            that.back()
          }
        }
      });
  },
  watch: {
    async limit_time (val) {
      if (val == 0) {
        clearInterval(this.timer);
        let that = this;
        await that.eveyoneQuesFunc('end', that.currentIndex)

        // 测评时间过期 自动提交后去掉弹窗 判断跳转页面 20241115
        // that.dialogConfig.name = 'assessDialog1';
        // that.dialogConfig.title = "提示";
        // that.dialogConfig.data = {
        //   record_id: that.record_id,
        //   ass_id: that.ass_id,
        //   assessName: that.assessName,
        //   class_id: that.class_id,
        //   show_result: that.show_result,
        //   use_duration: that.use_duration
        // };
      }
    },
    "questionData.form.is_sign": function (val) {
      this.questions[this.questionData.index].is_sign = val;
      this.$forceUpdate();
    },
    "questionData.form.answer": function (val) {
      if (val) {
        this.$set(this.questions[this.currentIndex], "answerState", "#DBE6FD");
        this.$set(this.questions[this.currentIndex], "answerColor", "#2462F5");
      } else {
        if (
          !this.questions[this.currentIndex].hasFile ||
          !this.questions[this.currentIndex].hasFile
        ) {
          this.$set(this.questions[this.currentIndex], "answerState", "#fff");
          this.$set(this.questions[this.currentIndex], "answerColor", "#333");
        }
      }
      this.$forceUpdate();
    },
    currentIndex: function (val) {
      if (val == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#FFFFFF";
        this.$refs.buNext.style.cursor = "not-allowed";
        this.$refs.buPrevious.style.cursor = "pointer";
      }
      if (val == 0) {
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "not-allowed";
        this.$refs.buNext.style.cursor = "pointer";
      }
      if (val > 0 && val < this.questions.length - 1) {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.cursor = "pointer";
        this.$refs.buNext.style.cursor = "pointer";
      }
    },
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  mounted() {
    
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      // clearInterval(this.timer1);
    }
  },
  methods: {
    stratCoundown(){
      if (this.limit_time > 0) {
        this.timer = setInterval(this.CountDown, 1000);
      } else {
        // this.timer1 = setInterval(this.timeCount, 1000);
      }
    },
    //过滤
    colorFunc (item) {
      if (item.is_right != 0) {
        this.$set(item, "answerState", "#dbe6fd");
        this.$set(item, "answerColor", "#2462f5");
      } else {
        this.$set(item, "answerState", "#ffffff");
        this.$set(item, "answerColor", "#666666");
      }
    },
    // 返回
    back() {
      this.$router.push({
        path:  `/${this.loginUserInfo && this.loginUserInfo.school_code}/user/myAssess`,
        query: {
          tabs: 0,
        },
      });
    },
    //跳转到该题
    async toQuestion(val, index, isRequest) {
      let that = this
      if(!isRequest){
        await this.eveyoneQuesFunc('current', this.currentIndex)
      }
      that.currentIndex = index;
      that.questionId = val.que_id
      that.questionType = val.type
      
      await services.questionGetbyassess({
        exam_id: this.ass_id,
        que_id: val.que_id,
        class_id: this.class_id,
        record_id: this.record_id,
        is_again: 2,
      }).then((res) => {
        // if (res.code == "0000") {
          // delete this.questions[index].que_id;
          that.questions[index] = Object.assign(that.questions[index],res.data);
          let obj = {
            que_id: this.questions[index].que_id,
            parent_id: this.questions[0].parent_id,
            answer: "",
            is_sign: "2",
          };
          if(res.data && res.data.user_log && res.data.user_log.answer) {
            obj.answer = res.data.user_log.answer
          }
          if(res.data && res.data.user_log && res.data.user_log.is_sign) {
            obj.is_sign = res.data.user_log.is_sign
          }
          if (that.questions[index].type == "1") {
            that.tebActive = "radio";
          } else if (that.questions[index].type == "2") {
            that.tebActive = "checkbox";
          } else if (that.questions[index].type == "5") {
            that.tebActive = "combination"; // type 为5 组合题
            obj.attachment = res.data.user_attachment
            // this.tebActive = 'fillBlanks'; // fillBlanks 代表填空题 目前没有
          } else if (that.questions[index].type == "4") {
            that.tebActive = "quesAnswer";
            obj.attachment = res.data.user_attachment
          } else if (that.questions[index].type == "3") {
            that.tebActive = "judge";
          }
          
          that.answerForm.answer_data[index] = obj;
          that.questionData = {
            data: that.questions[index],
            index: index,
            form: that.answerForm.answer_data[index],
            isAssess: '2', // 1练习 2 测评
          };
        // }
        // this.questions[index].isload = true;
      });
    },
    //跳转下一题
    next() {
      if (this.currentIndex < this.questions.length - 1) {
        // this.$refs.li[this.currentIndex + 1].click();
        this.eveyoneQuesFunc('next',this.currentIndex + 1)
      }
      if (this.currentIndex == this.questions.length - 1) {
        this.$refs.buNext.style.background = "#ECEAEA";
        this.$refs.buNext.style.color = "#999999";
        this.$refs.buNext.style.cursor = "not-allowed";
      } else {
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
      }
    },
    //跳转上一题
    previous() {
      if (this.currentIndex > 0) {
        // this.$refs.li[this.currentIndex - 1].click();
        this.eveyoneQuesFunc('prev', this.currentIndex - 1)
      }
      if (this.currentIndex == 0) {
        this.$refs.buPrevious.style.cursor = "not-allowed";
        this.$refs.buPrevious.style.background = "#ECEAEA";
        this.$refs.buPrevious.style.color = "#999999";
      } else {
        this.$refs.buPrevious.style.background = "#DBE6FD";
        this.$refs.buPrevious.style.color = "#999999";
        this.$refs.buNext.style.background = "#2462F5";
        this.$refs.buNext.style.color = "#FFFFFF";
      }
    },
    submitAssess(){
      this.eveyoneQuesFunc('last', this.currentIndex)
    },
    // 点击上一题 下一题 题号 先提交当前题目
    async eveyoneQuesFunc(type, currentInx){
      // type prev上一题 next下一题 current点击题号 last点击提交 end时间结束
      // subtype 1单题提交 2测评提交
      let that = this;
      let params = {
        exam_id: this.ass_id,
        record_id: this.record_id,
        que_id: this.questionId,
        subtype: type == 'last' || type == 'end' ? 2 : 1,
      }
      let dataArr = [];
      let isAnswer = false  // 当前题目是否答题了
      if(type == 'end'){ // 过期自动提交时 不调用card接口
        let allque = that.questions
        allque.forEach(function(item){
          if(item.is_right != 0){
            dataArr.push(Number(item.que_id));
          }
        })
      } else {
        await that.getMostCard().then(res => {
          if(res.code == '0000' && res.data){
            let allque =  res.data.items;
            allque.forEach(function(item){
              if(item.is_right != 0){
                dataArr.push(Number(item.que_id));
              }

            })
          }
        })
      }

      this.answerForm.answer_data.forEach(function (item) {
        if (item.que_id == that.questionId) {
          // if (item.is_sign == "1" || item.answer || (item.attachment  && item.attachment.length > 0)) {
            let allfile = []
            if(item.attachment && item.attachment.length > 0){
              allfile = that.stringToAttachment(item.attachment)
            }
            params = Object.assign(params, {
              is_sign: item.is_sign,
              answer: item.answer,
              que_id: item.que_id,
            })
            if(allfile.length > 0 ){
              params.attachment = JSON.stringify(allfile)
            } else {
              params.attachment = ''
            }
            // isAnswer 选择题、判断题、多选题需要用到改参数判断是否需要提交
            if (item.is_sign == "1" || item.answer){
              isAnswer = true;
              // if(that.questionType == '3'){
              //   if(Number(item.answer) > 0 && item.answer != ''){
              //     isAnswer = true;
              //   } else {
              //     params.answer = ''
              //   }
              // } else {
              //   isAnswer = true;
              // }
            }
            if (item.answer || (item.attachment  && item.attachment.length > 0)){
              if(dataArr.indexOf(Number(item.que_id)) == -1){
                dataArr.push(Number(item.que_id))
              }
            } else {
              if(dataArr.indexOf(Number(item.que_id)) > 0){
                dataArr.splice(dataArr.indexOf(Number(item.que_id)), 1)
              }
            }
          // }
        }
      });
      
      let answeredNum = dataArr.length;
      let questionsNum = that.questions.length;
      
        // 如果答题了 去提交单个题目  2022-12-5修改为 无论有没有答案均可以提交
      // if(type == "last" || type=='end' || isAnswer){
      if(type == "last" || type=='end' || that.questionType == "5" || that.questionType== "4" || ((that.questionType == "1" || that.questionType == "2" || that.questionType == "3") && isAnswer)){
        if(that.isSubmitting == false){
          that.isSubmitting == true
          if(type == 'last' || type=='end'){
            if (((answeredNum == questionsNum) && type =='last') || type=='end') {
              if(type == "end") {
                // 调用提交测评方法
                that.confirmMethod(params, type, currentInx)
              } else {
                // 全部题目答完后 用户点击提交时 二次确认后再提交测评
                Modal.confirm({
                  title: "确定提交该测评吗?",
                  okText: "确定",
                  cancelText: "取消",
                  onOk() {
                    // 调用提交测评方法
                    that.confirmMethod(params, type, currentInx)
                  },
                  onCancel(){},
                });
              }
            } else {
              that.isSubmitting == false
              if(type == 'last' ){
                this.dialogConfig.name = "assessDialog2";
                this.dialogConfig.title = "提示";
                this.dialogConfig.data = {
                  dataArr: dataArr,
                  questionsNum: questionsNum,
                  ass_id: that.ass_id,
                  assessName: that.assessName,
                  record_id: that.record_id,
                  params: {...params},
                  class_id: that.class_id,
                  show_result: that.show_result,
                  use_duration: that.use_duration
                };
              }
            }
          } else {
            await that.assessQuesition(params, type).then(res => {
              that.isSubmitting == false
              if(res.code == '0000'){
                if(type == 'prev' || type == 'next'){
                  that.toQuestion(this.questions[currentInx], currentInx, true)
                }
              }
            }).catch(err => {
              that.isSubmitting == false
            })
          }
        }
      } else {
        if(type == 'prev' || type == 'next'){
          this.toQuestion(this.questions[currentInx], currentInx, true)
        }
      }
      
    },
    // 全部题目答完后 用户点击提交确认弹窗后 提交测评方法
    async confirmMethod(params, type, currentInx){
      let that = this
      await this.assessQuesition(params, type).then(res => {
          that.isSubmitting == false
          if(res.code == '0000'){
            if(type == 'prev' || type == 'next'){
              this.toQuestion(this.questions[currentInx], currentInx, true)
            }
          }
        }).catch(err => {
          that.isSubmitting == false
        })
    },
    // 获取最新答题卡 答题状态 计算未答题目数量
    getMostCard(){
      let that = this
      return services.assessCard({
        exam_id: that.ass_id,
        class_id: that.class_id,
      }).then((res) => {
        return res
      })
    },
    // 提交测评的单个答题/完整练习 的请求
    assessQuesition (params, type) {
      // type prev上一题 next下一题 current点击题号 last点击提交 end时间结束
      // subtype 1单题提交 2测评提交
      let that = this
      // answer 为富文本字符串，请求前对其中的 HTML 标签进行转义
      if (params.answer && typeof params.answer === 'string') {
        params.answer = params.answer.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      return services.assessModify(params).then((res) => {
        if (res.code == "0000") {
          if(res.data && res.data.show_result){
            that.show_result = res.data.show_result
            that.use_duration = res.data.use_duration
            // that.$set(that.dialogConfig.data, 'use_duration', res.data.use_duration)
            // that.$set(that.dialogConfig.data, 'show_result', res.data.show_result)
          }
          if(params.subtype == 2){
            if(res.data && res.data.show_result){
              // show_result 交卷后展示测评结果 1开启 2关闭
              if(res.data.show_result == 1){
                that.$router.push({
                  //跳转到再次测评
                  path: `/${that.loginUserInfo && that.loginUserInfo.school_code}/user/myAssess/againAssess`,
                  query: {
                    ass_id: that.ass_id,
                    assessName: that.assessName,
                    record_id: that.record_id,
                    class_id: that.class_id,
                    tabs: 0,
                  },
                });
              } else {
                that.$router.push({
                  //跳转到测评结束页面
                  path: `/${that.loginUserInfo && that.loginUserInfo.school_code}/user/myAssess/endAssess`,
                  query: {
                    time: res.data.use_duration
                  },
                });
              }
            } 
            
          } else if (params.subtype == 1){
            that.getMostCard().then(res => {
              if(res.code == '0000' && res.data){
                that.questions = res.data.items;
                that.record_id = res.data.record_id
                that.questions.forEach(function (item) {
                  that.colorFunc(item);
                });
              }
            })
          }
        } else {
          that.$message.warning(res.message ? res.message : "提交失败");
        }
        return res
      });
    },
    // 将学生答题的附件列表 格式化为提交参数
    stringToAttachment(list) {
      let newdata = [];
      if(list.length > 0) {
        list.forEach(element => {
          if(element.type == 'video'){
            let obj1 = {
              file_name: element.filename,
              file_id: element.file_id, // 视频会上传腾讯云返回的file_id
              file_path: '',
              cover: '', // 视频视频封面
              file_url: element.file_url, // 视频的腾讯播放地址
            }
            if(element.id) {
              obj1.id = element.id
            }
            newdata.push(obj1)
          } else {
            let obj2 = {
              file_name: element.filename,
              file_path: element.url,
              file_id: '',
              cover: '',
              file_url: '',
            }
            if(element.id) {
              obj2.id = element.id
            }
            newdata.push(obj2)
          }
        });
      } 
      return newdata
    },
    //倒计时
    CountDown() {
      this.limit_time--;
      let tt = '';
      if(this.limit_time>-1){
        let hour = Math.floor(this.limit_time / 3600);
        let minutes = Math.floor(this.limit_time / 60) % 60;
        let seconds = Math.floor(this.limit_time % 60);
        if(hour < 10){
          tt = '0' + hour + ':'
        } else {
          tt = hour+':'
        }
        if(minutes < 10){
          tt+='0'
        }
        tt+=minutes+':'
        if(seconds < 10){
          tt+='0'
        }
        tt+= seconds.toFixed(0)
        let msg = "倒计时：" + tt;
        this.$refs.timeDom.innerHTML = msg;
      }
    },
    //用时
    timeCount() {
      this.time1++;
      let minutes = Math.floor(this.time1 / 60);
      let seconds = Math.floor(this.time1 % 60);
      let msg = "用时：" + minutes + "分钟 " + seconds + "秒";
      this.$refs.useTime.innerHTML = msg;
    },
    //关闭弹框
    cancleDialog(val) {
      this.dialogConfig.name = null;
    },
  },
};
</script>

<style scoped>
.c {
  padding-top: 10px;
}
.return {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2462f5;
  line-height: 32px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.main {
  background: #f6f6f6;
  padding-bottom: 10px;
}
.UserNav {
  box-shadow: 0px 0px 21px 0px rgba(25, 52, 116, 0.15);
}
.title {
  height: 40px;
  background: #fff;
  border-top: 3px solid #90b1ff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
}
.title .assessName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
}
.paper {
  margin-top: 20px;
  position: relative;
  padding-bottom: 80px;
}
.paper-left {
  width: calc(100% - 330px);
  height: auto;
  min-height: 530px;
  background: #ffffff;
  margin-right: 20px;
  float: left;
}
.paper-right {
  width: 310px;
  /* max-height: 566px; */
  background: #ffffff;
  float: left;
  padding-bottom: 20px;
}
.paper-right-title {
  width: 56px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #14202c;
  line-height: 32px;
  margin-top: 10px;
  margin-left: 30px;
}
.paper:after {
  content: "";
  display: block;
  clear: both; /* height: 0;overflow: hidden; 为了解决 IE 浏览器的兼容问题 */
  height: 0;
  overflow: hidden; /* visibility:hidden;为了去隐藏content中的内容 */
  visibility: hidden;
}
.button-box {
  padding-top: 30px;
  box-sizing: border-box;
  margin-top: 10px;
  height: 80px;
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 870px;
  z-index: 99;
}
.button-box div {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 22px;
  margin: 0 166px;
  display: inline-block;
  vertical-align: top;
}
.buPrevious {
  background: rgb(236, 234, 234);
  color: #999999;
  cursor: not-allowed;
}
.buPrevious:hover {
  background: #bbcdf3 !important;
  color: #ffffff !important;
}
.buNext {
  background: #2462f5;
  color: #fff;
  cursor: pointer;
}
.buNext:hover {
  background: #134bce !important;
  color: #ffffff !important;
}
ul {
  display: flex;
  flex-wrap: wrap;
  margin-left: 30px;
}
li {
  width: 32px;
  padding: 0 0;
  height: 32px;
  line-height: 32px;
  text-align: center;
  float: left;
  margin-right: 20px;
  margin-top: 15px;
  border: 1px solid #e4e4e4;
  cursor: pointer;
  font-size: 12px;
  position: relative;
}
li:hover {
  background: #dbe6fd;
  color: #999999;
}
li img {
  height: 14px;
  width: 14px;
  position: absolute;
  top: -7px;
  right: -7px;
}
.tip {
  height: 32px;
  display: flex;
  align-items: center;
  margin-left: 37px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.tip span {
  width: 29px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 32px;
  margin-right: 8px;
}
.answered {
  width: 16px;
  height: 16px;
  background: #dbe6fd;
  float: left;
  margin-right: 28px;
}
.noAnswer {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  float: left;
}
.submit {
  color: #fff;
  width: 220px;
  height: 30px;
  background: #2462f5;
  border-radius: 22px;
  line-height: 30px;
  text-align: center;
  margin-left: 45px;
  cursor: pointer;
}
.submit:hover {
  background: #134bce !important;
  color: #ffffff !important;
}
.paper-right-selects {
  overflow-y: auto;
}
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}
.time {
  margin: 20px auto;
  text-align: center;
  color: #e18c31;
  font-size: 16px;
}
</style>